import { AxisCode } from '@atlas/types'
import type { DeliverableItem } from '@atlas/ui-domain'
import type { FileWithTagsDTO } from '@/services/file.service'

/**
 * A delivered file as `DeliverablesCard` states it.
 *
 * Two axes are read here, and which they are is taxonomy knowledge the card does not hold:
 * `channel` supplies the filter pills, and `aspect_ratio` supplies the tile marker - the aspect
 * ratio being what distinguishes one delivered cut from another. A file carrying neither still
 * renders: it falls back to its binary type and stays reachable under "All".
 */
export const toDeliverableItem = (
	file: FileWithTagsDTO,
	thumbnails: Record<string, string | null> = {},
): DeliverableItem => ({
	id: file.fileId,
	name: file.fileName,
	contentType: file.contentType,
	previewUrl: thumbnails[file.fileId] ?? null,
	marker: file.tags.find((tag) => tag.axisCode === AxisCode.ASPECT_RATIO)?.label ?? null,
	channels: file.tags
		.filter((tag) => tag.axisCode === AxisCode.CHANNEL)
		.map((tag) => ({ code: tag.valueCode, label: tag.label })),
})

export const toDeliverableItems = (
	files: FileWithTagsDTO[],
	thumbnails: Record<string, string | null> = {},
): DeliverableItem[] => files.map((file) => toDeliverableItem(file, thumbnails))
